module.exports = __webpack_public_path__ + "static/media/bg.16d6621d.svg";